export default __webpack_public_path__ + "static/media/574.5237ff80.png";